import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import StarredIcon from '../../assets/starred_icon.svg';
import defaultAlbumThumbnail from '../../assets/default_album_thumbnail.svg';
import theme from '../../theme.js';

const AlbumCover = ({
  imageUrl,
  altText,
  isStarred,
  onClick,
  width = '100%',
  height = 'auto',
  sx = {},
  starIconSize,
}) => {
  const [imageSrc, setImageSrc] = useState(imageUrl || defaultAlbumThumbnail);

  useEffect(() => {
    setImageSrc(imageUrl || defaultAlbumThumbnail);
  }, [imageUrl]);

  const handleError = () => {
    setImageSrc(defaultAlbumThumbnail);
  };

  // StarredIcon: 기본 xs 20%, md/lg 15%. prop으로 오버라이드 가능
  const defaultSize = { xs: '20%', md: '15%' };
  const size = starIconSize || defaultSize;
  const starIconStyles = {
    top: '5%',
    left: '5%',
    width: size,
    height: size,
  };

  return (
    <Box
      sx={{
        position: 'relative',
        width,
        height,
        cursor: onClick ? 'pointer' : 'default',
        overflow: 'hidden',
        border: `1px solid ${theme.palette.grey.line}`,
        ...sx,
      }}
      onClick={onClick}
    >
      <img
        src={imageSrc}
        alt={altText}
        onError={handleError}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          display: 'block',
        }}
      />
      {isStarred && (
        <Box
          sx={{
            position: 'absolute',
            ...starIconStyles,
          }}
        >
          <img
            src={StarredIcon}
            alt="Starred"
            style={{
              width: '100%',
              height: '100%',
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default AlbumCover;
